import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts';
// import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader'
// import { BasicAreaChartTitle } from '../../../../Utils/Constants'
// import { basicAreaChart } from '../../Data/Charts/ApexChart'

interface ChartProps {
    title: string;
    data: {
        series: { name: string; data: number[] }[];
        categories: string[];
        si_unit: string;
    };
    height?: number;
    width?: number;
    size?: number;
}

const BasicAreaChart = ({ title, data, height, width, size = 6 }: ChartProps) => {
    var basicAreaChart: ApexOptions = {
        chart: {
            height: height ?? 350,
            type: 'area',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        series: data.series,
        // title: {
        //     text: title,
        //     align: 'left'
        // },
        // subtitle: {
        // text: 'Price Movements',
        // align: 'left'
        // },
        labels: data.categories,
        xaxis: {
            type: 'category',
        },
        yaxis: {
            title: {
                text: data.si_unit
            }
        },
        legend: {
            horizontalAlign: 'center'
        },
        colors: ['#e9622c', '#308e87', '#f39159', '#51bb25']
    };

    return (
        <Col sm={12} xl={size} className={`box-col-${size}`}>
            <Card>
                {/* <CommonCardHeader title={BasicAreaChartTitle} /> */}
                <CardBody>
                    <div id="basic-apex">
                        <ReactApexChart options={basicAreaChart} series={basicAreaChart.series} type="area" height={height ?? 350} width={width ?? 450 } />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}

export default BasicAreaChart;